/**
 * Local storage key of the signed-in user.
 */
export const USER_STORAGE_KEY = 'sveltia-cms.user';
